import React from 'react';
import { WarehouseMasterContextProvider } from '../../context';
import WarehouseScreenview from './WarehouseScreenview';

export default function WarehouseMasterView() {
  return (
    <WarehouseMasterContextProvider>
      <WarehouseScreenview />
    </WarehouseMasterContextProvider>
  );
}